export default __webpack_public_path__ + "static/media/operational.9447be64.png";